var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOutlinedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 12.5V14.1667M4.9987 17.5H14.9987C15.4407 17.5 15.8646 17.3244 16.1772 17.0118C16.4898 16.6993 16.6654 16.2754 16.6654 15.8333V10.8333C16.6654 10.3913 16.4898 9.96738 16.1772 9.65482C15.8646 9.34226 15.4407 9.16667 14.9987 9.16667H4.9987C4.55667 9.16667 4.13275 9.34226 3.82019 9.65482C3.50763 9.96738 3.33203 10.3913 3.33203 10.8333V15.8333C3.33203 16.2754 3.50763 16.6993 3.82019 17.0118C4.13275 17.3244 4.55667 17.5 4.9987 17.5ZM13.332 9.16667V5.83333C13.332 4.94928 12.9808 4.10143 12.3557 3.47631C11.7306 2.85119 10.8828 2.5 9.9987 2.5C9.11464 2.5 8.2668 2.85119 7.64168 3.47631C7.01655 4.10143 6.66536 4.94928 6.66536 5.83333V9.16667H13.332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlinedIcon);
export default __webpack_public_path__ + "static/media/LockOutlinedIcon.b9bc282cfef6bd394e19e225ff07c4ba.svg";
export { ForwardRef as ReactComponent };